import React from 'react';
import { Routes, Route } from 'react-router-dom';
import { IPanelPageProps } from '~/lib/PanelApp';
import LoginPane from './LoginPane';
import RecoverPane from './RecoverPane';
import ResetWithTokenPane from './ResetWithTokenPane';

import './Login.scss';
import { WithSearch } from '~/lib/helper/LocationHelper';
import PreLoginPanel from '~/components/PreLoginPanel';

export default class LoginPage extends React.Component<IPanelPageProps> {
    render() {
        return (
            <div className="loginPage">
                <PreLoginPanel>
                    <Routes>
                        <Route
                            path="/"
                            element={<WithSearch>{(search) => <LoginPane redirectUrl={search.get('r')} />}</WithSearch>}
                        />
                        <Route path="/forgotpassword" element={<RecoverPane />} />
                        <Route path="/resetpassword" element={<ResetWithTokenPane />} />
                    </Routes>
                </PreLoginPanel>
            </div>
        );
    }
}
